// extracted by mini-css-extract-plugin
export var body = "RlDVCrO4m0OEF4vDfBSF";
export var fontBold = "jGKaUkgN51KOqmxgJHuw";
export var fontMedium = "sNLlgOhOpAeIkSGj5ORW";
export var fontRegular = "WslDiUpoHNwEvsvnRgN_";
export var large = "oMkaTvGBuVIOeALKC5vi";
export var micro = "QOmhUgDyB8DOivO_8hFB";
export var mini = "kbuoZo7jLCYjZtqHXgNw";
export var root = "jlNgTVmVIkUMTcNRWdPw";
export var small = "CAQfnuULo5W7Cij855Jb";